// Debounce function
// Lifted from underscore.js (https://github.com/jashkenas/underscore/blob/master/underscore.js)
/* eslint-disable */
export default function debounce(func, wait, immediate) {
	var timeout, args, context, timestamp, result;

	function later() {
		let now = new Date().getTime();
		var last = now - timestamp;

		if (last < wait && last >= 0) {
			timeout = setTimeout(later, wait - last);
		} else {
			timeout = null;
			if (!immediate) {
				result = func.apply(context, args);
				if (!timeout) {
					context = args = null;
				}
			}
		}
	}

	return () => {
		let now = new Date().getTime();
		context = this;
		args = arguments;
		timestamp = now;
		var callNow = immediate && !timeout;
		if (!timeout) {
			timeout = setTimeout(later, wait);
		}

		if (callNow) {
			result = func.apply(context, args);
			context = args = null;
		}

		return result;
	};
}
/* eslint-enable */
